// extracted by mini-css-extract-plugin
export default {"slide1":"slide1_slide1__9i0Kc","slide1__bg":"slide1_slide1__bg__tJQht","slide1__box":"slide1_slide1__box__Yy-wM","slide1__box__title":"slide1_slide1__box__title__WBDX7"};